// Enums e Função de Consultor
enum TechnicalSDR {
  ISADORA_SANTOS = "Isadora dos Santos Landim",
}

// Defina o tipo para as opções de consultores
interface ConsultantOption {
  value: string;
  label: string;
}

export const getSdrOptions = ( savedValue?: string): ConsultantOption[] => {
  const baseOptions: ConsultantOption[] = [
    { value: "", label: "-" },  // Adiciona a opção vazia no início
  ];

  let specificOptions: ConsultantOption[] = [];

    const allConsultants = [
      ...Object.values(TechnicalSDR),
      ...Object.values(TechnicalSDR),
      ...Object.values(TechnicalSDR),
      ...Object.values(TechnicalSDR),
      ...Object.values(TechnicalSDR),
      ...Object.values(TechnicalSDR),
      ...Object.values(TechnicalSDR),
      ...Object.values(TechnicalSDR),
      ...Object.values(TechnicalSDR)
    ];

    // Remove duplicatas usando Set
    const uniqueConsultants = [...new Set(allConsultants)];

    // Ordena alfabeticamente
    uniqueConsultants.sort();

    specificOptions = uniqueConsultants.map(value => ({
      value,
      label: value,
    }));

  // Adiciona o valor salvo às opções, caso não esteja presente nas opções específicas
  if (savedValue && !specificOptions.some(option => option.value === savedValue)) {
    specificOptions.unshift({ value: savedValue, label: savedValue });
  }

  return [...baseOptions, ...specificOptions]; // Combina a opção vazia com as específicas e a opção salva
}
